import { React } from 'react'
import { Checkbox, Tooltip } from 'antd'
import classNames from 'classnames'

import groupBlackSVG from '@/assets/images/group-black-24.svg'

const getTableInfo = (styles, selectedRowKeys, onSelectChange) => {
  const onRow = (record) => {
    return {
      onClick: (e) => {
        console.log(' - click ', e, record)

        if (e.target.type !== 'checkbox' && !e.target.closest('.ant-checkbox-wrapper')) {
          const key = record.key || record.id
          const isSelected = selectedRowKeys && selectedRowKeys.includes(key)

          if (onSelectChange) {
            if (isSelected) {
              onSelectChange(
                selectedRowKeys.filter((k) => k !== key),
                selectedRowKeys.filter((k) => k !== key).map(() => record),
              )
            } else {
              onSelectChange(
                [...(selectedRowKeys || []), key],
                [...(selectedRowKeys || []), key].map(() => record),
              )
            }
          }
        }
      },
    }
  }

  const columns = [
    {
      dataIndex: 'id',
      key: 'avatar',
      width: 32,
      render: (_, record) => {
        return <img src={groupBlackSVG} alt={record.name} />
      },
    },
    {
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => {
        const { name, members } = record
        const memberLabels = Array.isArray(members)
          ? members.map((m) => m.user_name || m.user_email).filter(Boolean)
          : []
        const tooltipTitle = memberLabels.length > 0 ? memberLabels.join(', ') : null

        const nameSpan = <span className={classNames(styles.name)}>{name}</span>

        return (
          <div className={classNames(styles.info)}>
            {tooltipTitle == null ? (
              nameSpan
            ) : (
              <Tooltip title={tooltipTitle} placement="topLeft">
                {nameSpan}
              </Tooltip>
            )}
          </div>
        )
      },
    },
    {
      key: 'selection',
      width: 48,
      render: (_, record) => {
        const key = record.key || record.id
        const isSelected = selectedRowKeys && selectedRowKeys.includes(key)

        return (
          <Checkbox
            checked={isSelected}
            onChange={(e) => {
              e.stopPropagation()
              const { checked } = e.target

              if (onSelectChange) {
                if (checked) {
                  onSelectChange(
                    [...(selectedRowKeys || []), key],
                    [...(selectedRowKeys || []), key].map(() => record),
                  )
                } else {
                  onSelectChange(
                    (selectedRowKeys || []).filter((k) => k !== key),
                    (selectedRowKeys || []).filter((k) => k !== key).map(() => record),
                  )
                }
              }
            }}
          />
        )
      },
    },
  ]

  return { columns, onRow }
}

export default getTableInfo
